import { gql } from '@apollo/client'
import { SABRE_PRODUCT_FRAGMENT } from '../fragments'

export const SABRE_GET_PRODUCT = gql`
  query GetProduct($upc: String!) {
    product(upc: $upc) {
      ...Product
    }
  }
  ${SABRE_PRODUCT_FRAGMENT}
`
